
    import TheSalonItem from './components/TheSalonItem.vue'
    export default {
        name: "the-salon-list",
        props: {
            salons: {
            type: Array,
            required: true,
            },
        },
        components: {
            TheSalonItem
        },
        data: () => ({
          isMounted: false,
        }),
        mounted() {
          this.isMounted = true;
        }
    };
